export const WORKBOOK_PINS_ENTITY_NAME = 'WorkbookPins';
export const WORKBOOK_ENTITY_NAME = 'Workbook';
export const WORKBOOK_LIST_ENTITY_NAME = 'WorkbookList';
